import { render, staticRenderFns } from "./KnNotFount.vue?vue&type=template&id=6fef0b8d"
import script from "./KnNotFound.js?vue&type=script&lang=js&external"
export * from "./KnNotFound.js?vue&type=script&lang=js&external"
import style0 from "./KnNotFount.vue?vue&type=style&index=0&id=6fef0b8d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports